import { TFunction } from 'i18next'
import { StringSchema } from 'yup'

import { stringSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const nonEmptyStringSchema = (
  t: TFunction<'translation', undefined>,
  charLimit = 255,
): StringSchema<string> =>
  stringSchema(t, charLimit)
    .defined()
    .typeError(t(formTranslation.errors.fieldRequired))
    .required(t(formTranslation.errors.fieldRequired))
